import React from 'react';
import FrontRecapitulatif from './recapitulatif';
import FrontFooter from './footer'
import FrontProgress from './progress';

export default class FrontPayment extends React.Component {
    
    constructor(props) {
        super(props);
        this.timer = false
    }

    periodic() {
        if ( ! this.props.devis.params.paymentError ) {
            this.props.checkStatus()
        }
    }

    componentDidMount() {
        this.timer = setInterval(
            this.periodic.bind(this),
            4000
        )
    }

    componentWillUnmount() {
        if ( this.timer ) {
            clearInterval( this.timer )
            this.timer = false
        }
    }


    render() {
        const params = this.props.devis.params
        const container = {
            devis:this.props.devis,
            changeParams:this.props.changeParams,
            setPage: this.props.setPage
        }
        return <>
        <FrontProgress comparateursCompleted={true} setPage={this.props.setPage} page={this.props.page} topRef={this.props.topRef}/>
        <div className="container">

            <div className="contentbox">
                <div className="contentvbox">
                <h1 className="top_title">Procédez au paiement de l'acompte</h1>
                <p className="text centered">
                Le montant de l'acompte s'élève à <b>{container.devis.toPay()} €</b>.
                </p>
                {this.props.embeded?
                <p className="text">
                    <span>En mode commercial : vous pouvez envoyer un lien de paiement au client : les documents seront envoyés automatiquement dès réception du paiement.</span>
                    <a className="button button_subscribe" onClick={this.props.sendPaymentLink}>
                        Envoyer un lien de paiement au client
                    </a>
                    <span>ou cliquez sur le bouton ci-dessous si le paiement a déjà été réalisé depuis une autre source que le paiement CB en ligne.</span>
                    <a className="button button_subscribe red" onClick={this.props.validatePayment}>
                        Souscrire sans paiement <span>▸</span>
                    </a>
                    <span>ou encore, entrer les données de carte bancaire vous même ci-dessous.</span>
                </p>:''}
                { params.paymentError ? <>
                <p>Le paiement a échoué&nbsp;:</p>
                <p className="error">
                    {params.paymentError}
                </p>
                <p>
                    <a className="button button_subscribe" onClick={()=>container.changeParams({paymentError:false})}>
                        Réessayer <span>▸</span>
                    </a>
                </p>
                </>:<iframe src={this.props.api.paymentUrl(this.props.devis._id.$oid)} name="paymentFrame"/>
                }
                </div>
            </div>
            <div className="contentbox_middle"/>

            <div className="contentbox contentbox_right">
                <FrontRecapitulatif api={this.props.api} devis={this.props.devis} container={container}/>

                <h1 className="subscribe">Contactez nous par téléphone</h1>
                <a href="tel:0974772861" className="tel">09 74 77 28 61</a>
            </div>

            </div>

        </>
    }
}